/**
 * Agent Service
 * 
 * Business logic layer for agent operations.
 * Part of the 3-layer architecture (Repository → Service → React Query Hooks)
 */

import { repositories } from '../repositories';
import type { Agent, AgentStatus, AgentWithQueues } from '../repositories/AgentRepository';

export class AgentService {
  /**
   * Get current agent by user ID
   */
  async getCurrentAgent(userId: string): Promise<AgentWithQueues | null> {
    return await repositories.agents.getByUserId(userId);
  }

  /**
   * Update agent status
   */
  async updateAgentStatus(userId: string, status: AgentStatus): Promise<Agent | null> {
    return await repositories.agents.updateStatus(userId, status);
  }

  /**
   * Get all active agents
   */
  async getActiveAgents(): Promise<Agent[]> {
    return await repositories.agents.getActiveAgents();
  }

  /**
   * Subscribe to agent status changes
   */
  subscribeToStatusChanges(userId: string, callback: (agent: Agent) => void): () => void {
    return repositories.agents.subscribeToAgentStatusChanges(userId, callback);
  }
}

// Export singleton instance
export const agentService = new AgentService();
